import {makeLxTranslations} from "@lxo-blocks/react";

const CREDENTIALS_FORM_TRANSLATION =  makeLxTranslations({
    namespace: "credentialsTranslations",
    translations: {
        SET_NEW_PASSWORD_SUCCESSFULLY: "Passwort wurde neu festgelegt.",
        TOKEN_LOGIN_ERROR: "Beim Login über die Partneranwendung trat ein Fehler auf." +
            " Bitte loggen Sie sich mit Ihrer Email und Passwort ein.",
        LOGIN_FAILED_TRY_AGAIN: "Bitte erneut versuchen, <anchor href='https://support.lexoffice.de/de-form/articles/6979112-ich-kann-mich-nicht-einloggen-und-weiss-nicht-warum' target='_blank'>oder lesen Sie hier, woran es liegen könnte, dass Sie sich nicht einloggen können.</anchor>",
        LOGIN_FAILED: "Anmeldung fehlgeschlagen.",
        EMAIL_REQUIRED: "Bitte geben Sie Ihre E-Mail-Adresse ein",
        PASSWORD_REQUIRED: "Bitte geben Sie Ihr Passwort ein",
        SIGNIN: "ANMELDEN",
        EMAIL: "E-Mail",
        PASSWORD: "Passwort",
    }
});

export {CREDENTIALS_FORM_TRANSLATION};
